module.exports = __webpack_public_path__ + "static/media/TitleScreen00.91980955.png";